export default __webpack_public_path__ + "static/2-sexy-2018-icon-ff28429f297c6ccafadceb1d95e9c2cb.png";